import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';
import { formatNumberSpacing } from 'src/constants';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const BarChart = ({ data, label, xLabel, yLabel, valueKey, color }) => {
  const labels = data?.map((item) => (item.material ? `${item.material}` : `${item.firstName} ${item.lastName}`));

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: label,
        data: data?.map((item) => item[valueKey].toFixed(2)),
        backgroundColor: color || '#88C070',
        borderColor: color ? color : '#88C070',
        hoverBackgroundColor: color || '#88C070',
        hoverBorderColor: color || '#88C070',
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: 'top',
        labels: {
          font: {
            size: 16,
          },
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const orderCount = data[context.dataIndex]?.orderCount;
            return `${context.dataset.label}: ${formatNumberSpacing(context.raw)}${
              orderCount !== undefined ? ` (Orders: ${orderCount})` : ''
            }`;
          },
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: xLabel,
        },
        ticks: {
          autoSkip: false,
          maxRotation: data && data[0]?.material === 'Cement' ? 0 : 90,
          minRotation: data && data[0]?.material === 'Cement' ? 0 : 90,
        },
      },
      y: {
        title: {
          display: true,
          text: yLabel,
        },
      },
    },
  };

  return <Bar data={chartData} options={options} />;
};

export default BarChart;
